
import { Routes, Route, useLocation } from "react-router-dom";
import productos from "../../hooks/productos.json";
import ProductosListado from "./listado";
import Producto from "./producto";

const Productos = () => {
    const { pathname } = useLocation();
    return (
        <>
            <Routes>
                <Route path="">
                    <Route index={true} element={<ProductosListado />}></Route>
                    <Route path="/*" element={productos.find(producto => producto.id == pathname.split('/').pop()) ? <Producto /> : <ProductosListado />}></Route>
                </Route>
            </Routes>
        </>
    );
}

export default Productos;